import { NotFoundPage, PageData } from "../types";
import { ApiInstance } from "./instance";
import { populateSEO } from "@shared/lib";

export class NotFoundPageApi extends ApiInstance {
  constructor(locale = "id-ID") {
    super(locale);
  }

  getNotFoundPageData(): Promise<PageData<NotFoundPage>> {
    const query = {
      populate: {
        buttons: {
          populate: ["icon", "color"],
        },
        image: {
          populate: "*",
        },
        ...populateSEO,
      },
    };

    return this._SendWithQuery("/not-found-page", query);
  }
}
